import { ArrowLeftOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  DatePicker,
  Modal,
  Row,
  Spin,
  Typography,
  message,
} from 'antd';
// import { postEjecucionesBySearch } from 'api/pae/ejecuciones';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import getFormattedValues from 'utils/formatValues';
import { onError } from 'utils/handlers';

const { Text } = Typography;

const BusquedaEjecuciones = ({
  onFinishBusqueda,
  visible,
  setVisible,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // Regla reutilizable: obliga a capturar ambos extremos del rango
  const requirePairedField = (pairedFieldName) => ({ getFieldValue }) => ({
    async validator(_, value) {
      const pairedValue = getFieldValue(pairedFieldName);
      const hasValue = value !== undefined && value !== null && value !== '';
      const hasPaired = pairedValue !== undefined && pairedValue !== null && pairedValue !== '';
      if ((hasValue && !hasPaired) || (!hasValue && hasPaired)) {
        throw new Error('Debe capturar el rango completo (inicial y final).');
      }
    },
  });

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const params = getFormattedValues(values);
      const keys = Object.keys(params);
      const validProps = keys.filter((prop) => params[prop]);
      if (validProps.length) {
        onFinishBusqueda(params);
        onCancel();
      } else {
        message.info('Ingrese al menos un parámetro de búsqueda');
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const Title = ({ text }) => (
    <Col span={24}>
      <Text style={{ color: '#000000DA', fontSize: 17 }}>
        {text}
      </Text>
    </Col>
  );

  Title.propTypes = { text: PropTypes.string.isRequired };

  const FormSection = ({ children }) => (
    <Row gutter={10}>
      {children}
    </Row>
  );

  FormSection.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const PairedTextRange = ({
    nameStart,
    labelStart,
    nameEnd,
    labelEnd,
  }) => (
    <>
      <Col xs={24} sm={24} md={12}>
        <Form.Item
          name={nameStart}
          label={labelStart}
          dependencies={[nameEnd]}
          rules={[requirePairedField(nameEnd)]}
        >
          <Input allowClear />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12}>
        <Form.Item
          name={nameEnd}
          label={labelEnd}
          dependencies={[nameStart]}
          rules={[requirePairedField(nameStart)]}
        >
          <Input allowClear />
        </Form.Item>
      </Col>
    </>
  );

  PairedTextRange.propTypes = {
    nameStart: PropTypes.string.isRequired,
    labelStart: PropTypes.string.isRequired,
    nameEnd: PropTypes.string.isRequired,
    labelEnd: PropTypes.string.isRequired,
  };

  const controls = [
    {
      text: 'Regresar',
      icon: <ArrowLeftOutlined />,
      onClick: () => onCancel(),
    },
    {
      text: 'Buscar',
      icon: <SearchOutlined />,
      onClick: () => onFinish(),
    },
  ];

  return (
    <Modal
      open={visible}
      closable={false}
      footer={null}
      maskClosable={!loading}
      keyboard={!loading}
      title={(
        <FormSubmitControls
          label="Búsqueda Ejecuciones"
          controls={controls}
          loading={loading}
        />
      )}
      onCancel={onCancel}
      forceRender
      centered
      width={800}
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          onFinish={() => onFinish()}
          scrollToFirstError
        >
          <FormSection>
            <PairedTextRange
              nameStart="folio_inicial_de_ejecucion"
              labelStart="Folio inicial de reporte moroso"
              nameEnd="folio_final_de_ejecucion"
              labelEnd="Folio final de reporte moroso"
            />
          </FormSection>
          <FormSection>
            <PairedTextRange
              nameStart="folio_id_inicial_de_ejecucion"
              labelStart="Folio ID inicial de reporte moroso"
              nameEnd="folio_id_final_de_ejecucion"
              labelEnd="Folio ID final de reporte moroso"
            />
          </FormSection>
          <FormSection>
            <PairedTextRange
              nameStart="folio_id_inicial_de_generacion"
              labelStart="Folio ID inicial de generación de reporte moroso"
              nameEnd="folio_id_final_de_generacion"
              labelEnd="Folio ID final de generación de reporte moroso"
            />
          </FormSection>
          <FormSection title="Datos de Generación">
            <Col span={24}>
              <Form.Item
                name="rango_de_fecha_de_ejecucion"
                label="Rango de fecha de reporte moroso"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value === null) return Promise.resolve();
                      const isValid = Array.isArray(value)
                        && value.length === 2
                        && value[0]
                        && value[1];
                      return isValid
                        ? Promise.resolve()
                        : Promise.reject(new Error('Seleccione fecha inicial y final.'));
                    },
                  },
                ]}
              >
                <DatePicker.RangePicker
                  disabled={loading}
                  format="DD/MM/YYYY"
                  placeholder={['', '']}
                />
              </Form.Item>
            </Col>
          </FormSection>
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

BusquedaEjecuciones.propTypes = {
  setVisible: PropTypes.func.isRequired,
  onFinishBusqueda: PropTypes.func.isRequired,
  visible: PropTypes.bool,
};

BusquedaEjecuciones.defaultProps = {
  visible: false,
};

export default BusquedaEjecuciones;
